import { production } from 'app/config/constants'

const PROD_ID = 100044323
const STAGE_ID = 106588076

export function ym(goal: string, data?: object): void {
  const id = production ? PROD_ID : STAGE_ID

  window.ym?.(id, 'reachGoal', goal, data)
}
